

import Vue from 'vue'
import CloseIcon from '@/assets/svgs/x_close_icon.svg?inline'
import CarrusIcon from '@/assets/svgs/carrus_icon_colored.svg?inline'
import DashboardIcon from '@/assets/svgs/dashboard_icon.svg?inline'
import SearchIcon from '@/assets/svgs/search_icon.svg?inline'
import DropdownArrow from '@/assets/svgs/dropdown_arrow.svg?inline'
import BookmarkIcon from '@/assets/svgs/bookmark_icon.svg?inline'
import JobStatsIcon from '@/assets/svgs/job_stats_icon.svg?inline'
import CoursesIcon from '@/assets/svgs/library_books_icon.svg?inline'
import UsersIcon from '@/assets/svgs/supervisor_account_icon.svg?inline'
import AssessmentsIcon from '@/assets/svgs/assessment_icon.svg?inline'
import ReportsIcon from '@/assets/svgs/report_icon.svg?inline'
import CalendarIcon from '@/assets/svgs/calendar_icon.svg?inline'

interface Data {
  adminTabShowing: boolean
  isSearchTabExpanded: boolean
}
interface Methods {}
interface Computed {}
interface Props {}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'NavDrawer',
  data: () => ({
    adminTabShowing: true,
    isSearchTabExpanded: false
  }),
  components: {
    CloseIcon,
    CarrusIcon,
    DashboardIcon,
    SearchIcon,
    DropdownArrow,
    BookmarkIcon,
    JobStatsIcon,
    CoursesIcon,
    UsersIcon,
    AssessmentsIcon,
    ReportsIcon,
    CalendarIcon
  },
  methods: {
    isFavoritesTabShowing: function () {
      if (!['/admin/favorites', '/admin/search'].includes(this.$route.path)) {
        this.isSearchTabExpanded = false
      }
      return this.isSearchTabExpanded
    }
  }
})
